export default "__VITE_ASSET__BSHT1bHL__"